import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { CircleNotch } from '@phosphor-icons/react';

/**
 * Redirects already-authenticated users away from login/register pages.
 */
export function RedirectIfAuth({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading, isDemoMode } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#0D0F14]">
        <CircleNotch size={32} className="animate-spin text-teal-500" />
      </div>
    );
  }

  if (isAuthenticated || isDemoMode) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
